import { createSlice, isAction } from "@reduxjs/toolkit";
import {
  addResourceRequest,
  fetchResourceRequestById,
  fetchResourceRequests,
  updateResourceRequest,
  updateStatusInResourceRequest,
} from "./thunk";

interface ResourceRequestState {
  ResourceRequestList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedResourceRequest: any;
}

const initialState: ResourceRequestState = {
  ResourceRequestList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedResourceRequest: null,
};

const ResourceRequestSlice = createSlice({
  name: "ResourceRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchResourceRequests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchResourceRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.ResourceRequestList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchResourceRequests.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch ResourceRequests";
      })
      .addCase(fetchResourceRequestById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchResourceRequestById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedResourceRequest = action.payload;
      })
      .addCase(fetchResourceRequestById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addResourceRequest.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.ResourceRequestList = state.ResourceRequestList.map((pkg) =>
          pkg.id === action.payload.id ? action.payload : pkg
        );
      })
      .addCase(addResourceRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to add ResourceRequests";
      })
      .addCase(updateResourceRequest.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.ResourceRequestList = state.ResourceRequestList.map((pkg) =>
          pkg.id === action.payload.id ? action.payload : pkg
        );
      })
      .addCase(updateResourceRequest.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to update ResourceRequests";
      })
      .addCase(updateStatusInResourceRequest.fulfilled, (state, action) => {
        // if (!action.payload?.data.id) return;
        // state.ResourceRequestList = state.ResourceRequestList.map((pkg) =>
        //   pkg.id === action.payload.data.id ? action.payload.data : pkg
        // );
      })

      .addCase(updateStatusInResourceRequest.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch ResourceRequests";
      });
  },
});

export default ResourceRequestSlice.reducer;
